<template>
	<div class="footer" :style="{backgroundImage:`url(${ footerBackgroundImage})`}" >
		<div :style="{backgroundColor: footerBackgroundColor}" class="footer--bg"></div>
		<div class="footer--inner">
			<div class="am-g">
				<!-- 链接中心 -->
				<div class="am-u-md-2 ">
					
					<div :style="{color: footerFontColor}" class="footer_main--column">
						<strong :style="{color: footerFontColor}" class="footer_main--column_title">{{bottomInfoList[7].itemValue}}</strong>
						
						<div :class="show_edit_icon" style="display: none; justify-content: center; ">
							<a :href="$globalConfigApiHost+'/items/manage/edit/'+itemId_bottom_info" target="_blank" >
								<img src="../../../assets/images/help/edit-white.svg" alt="直达编辑页" title="点此图片,直达编辑页">
							</a>
						</div>
						
						<ul class="footer_navigation">
							<li v-for="n in generateNumbers(product_begin, product_end)" :key="n" :style="{'--color': footerFontColor}" class="footer_navigation--item-self">
								<a :href="`${bottomInfoList[n].itemValue}`" :target="`${bottomInfoList[n].itemDetail}`" >
									<span :style="{color: footerFontColor}" >{{bottomInfoList[n].itemName}}</span>
								</a>
							</li>
						</ul>
					</div>
					
				</div>
				
				<div class="am-u-md-3 ">
					<div class="footer_main--column">
						<strong :style="{color: footerFontColor}" class="footer_main--column_title">{{bottomInfoList[2].itemName}}</strong><!-- 联系详情 -->
						
						<div :class="show_edit_icon" style="display: none; justify-content: center; ">
							<a :href="$globalConfigApiHost+'/items/manage/edit/'+itemId_bottom_info" target="_blank" >
								<img src="../../../assets/images/help/edit-white.svg" alt="直达编辑页" title="点此图片,直达编辑页">
							</a>
						</div>
						
						<ul class="footer_contact_info">
							<li class="footer_contact_info--item" style="margin-top:5px;"><!-- 服务专线：15284734274-->
								<!-- <i :style="{color: footerFontColor}" class="am-icon-phone"></i>		<span :style="{color: footerFontColor}">{{bottomInfoList[1.itemAlias}}：{{bottomInfoList[1.itemDetail}}</span> -->
								<a :href="'tel:'+bottomInfoList[1].itemDetail">
									<i :style="{color: footerFontColor}" class="am-icon-phone"></i>		
									<span :style="{color: footerFontColor}">{{bottomInfoList[1].itemAlias}}：{{bottomInfoList[1].itemDetail}}</span>
								</a>
							</li>
							<li class="footer_contact_info--item" style="margin-top:3px;"><i :style="{color: footerFontColor}" class="am-icon-map-marker"></i>	
								<span :style="{color: footerFontColor}">{{bottomInfoList[2].itemValue}}<!-- 贵州省贵阳市南明区--></span>
							</li>
							<li class="footer_contact_info--item" style="margin-top:2px;"><i :style="{color: footerFontColor}" class="am-icon-clock-o"></i>		
								<span :style="{color: footerFontColor}">{{bottomInfoList[2].itemAlias}}, {{bottomInfoList[2].itemDetail}}<!-- 周一 ~ 周日, 8:00 - 23:00 --> </span>
							</li>
						</ul>
					</div>
				</div>
				
				<div class="am-u-md-4 ">
					<div class="footer_main--column">
						<strong :style="{color: footerFontColor}" class="footer_main--column_title">{{bottomInfoList[3].itemName}}</strong><!--  地址导航\关于我们 -->
						
						<div :class="show_edit_icon" style="display: none; justify-content: center; ">
							<a :href="$globalConfigApiHost+'/items/manage/edit/'+itemId_bottom_info" target="_blank" >
								<img src="../../../assets/images/help/edit-white.svg" alt="直达编辑页" title="点此图片,直达编辑页">
							</a>
						</div>
							
						<div class="footer_about container" id="mapAddr">
						</div>
					</div>
				</div>
				
				<div class="am-u-md-3 ">
					<div class="footer_main--column">
						<strong :style="{color: footerFontColor}" class="footer_main--column_title">{{bottomInfoList[8].itemValue}}</strong><!-- 扫码关注 -->
						
						<div :class="show_edit_icon" style="display: none; justify-content: center; ">
							<a :href="$globalConfigApiHost+'/items/manage/edit/'+itemId_bottom_info" target="_blank" >
								<img src="../../../assets/images/help/edit-white.svg" alt="直达编辑页" title="点此图片,直达编辑页">
							</a>
						</div>
						
						<ul class="footer_contact_info" style="display: flex; flex-wrap: wrap;">
							<div v-for="n in generateNumbers(QR_begin, QR_end)" :key="n">
								<li class="footer_contact_info--item" style="text-align: center; padding: ;">
									<div class="oray-code-box">
										<img width="94" height="94" :src="bottomInfoList[n].itemDetail" :alt="bottomInfoList[n].itemAlias">
									</div>
									<p :style="{color: footerFontColor}" class="footer_contact_info--item code-desc" style="white-space: nowrap;">{{bottomInfoList[n].itemAlias}}</p>
								</li>
							</div>
						</ul>
					</div>
				</div>
			</div>
			
			<div class="am-g" style="padding-bottom: 10px;">
				<a href="https://beian.miit.gov.cn/" target="_blank">
					<span :style="{color: footerFontColor}">{{bottomInfoList[5].itemValue}}</span><!-- 黔ICP备2025043042号-1 -->
				</a>
				<!-- <span class="separator">|</span> -->
				<a :href="beianUrl" target="_blank">
					<img style="padding-left: 20px;top: -3px;position: relative;" :src="networkSecurityPicUrl">						
					<span :style="{color: footerFontColor}" >{{bottomInfoList[5].itemDetail}}</span><!-- 贵公网安备52010202004128号 -->
				</a>
				<!-- <span class="separator">|</span> -->
				<a :href="serveUrl" target="_blank">
					<span :style="{color: footerFontColor}" >　技术支持：</span>
					<span :style="{color: footerFontColor}" >　想能愿（贵州）科技有限公司</span>
				</a>
				
				<a v-if="manageShow==5" :href="backServeUrl" target="_blank" id="manage">
					<span @click="manageShowClick">&nbsp;后台管理</span>
				</a>
				
				<button style="width: 50px;height: 10px; background-color: transparent; border: none;" @click="manageShowClick"></button>
				<!-- <span class="separator">|</span> -->
				<!-- <a href="https://xny.world:18383/agreement.html" class="footer-link" >隐私政策</a> -->
				<a href="https://xny.world/#/n/nId?showDetailNewId=90&menu_3_text=%E5%85%AC%E5%8F%B8%E6%96%B0%E5%8A%A8%E6%80%81&n_detail_text=%E6%96%87%E7%AB%A0%E8%AF%A6%E6%83%85&link_text=%E6%9F%A5%E7%9C%8B%E6%9B%B4%E5%A4%9A" class="footer-link" >隐私政策</a>
				
				<span class="separator" style="margin: 0 1rem;">|</span>
				<a href="https://xny.world/#/c" class="footer-link" >联系我们</a>
			</div>
		</div>
		
		<div class="side-toolbar" id="side-toolbar" v-if="isVisable==true">
			<!-- 			
				<div class="popup button" id="home-comment">
					<i class="iconfont icon-comment"></i>
				</div>
				<div class="ui popup dark left center transition hidden" style="inset: 47.4944px 40px auto auto;">评论</div>
				<div class="toolbar-appeal popup button">
					<i class="iconfont icon-report"></i>
				</div>
				<div class="ui popup dark left center transition hidden" style="inset: 93.4886px 40px auto auto;">仓库举报</div>
			 -->
			<div class="button gotop popup active" id="gotop" @click="goTop()" >
				<i class="am-icon-chevron-up" ></i>
			</div>
			<div style="inset: 139.483px 40px auto auto; color: #eeeeee; margin-right: -12px;">回到顶部</div>
		</div>
		
	</div>
</template>

<script>
import $ from 'jquery';
import AMapLoader from '@amap/amap-jsapi-loader';
// import VueBaiduMap 	from 'vue-baidu-map/components/map/Map.vue';
// import BaiduMap 	from 'vue-baidu-map';
// import {BmGeolocation, BmLocalSearch, BmNavigation, BmMarker, BmLabel, BmInfoWindow} 	from 'vue-baidu-map';

export default {
	name: "Footer",
	// components:{VueBaiduMap},
	// components:{BaiduMap},
	components:{AMapLoader},
	// components:{
	// 	// 地图
	// 	BaiduMap,
	// 	// 手动定位控件
	// 	BmGeolocation,
	// 	// 检索控件
	// 	BmLocalSearch,
	// 	// 地图放大缩小控件
	// 	BmNavigation,
	// 	// 点标记控件
	// 	BmMarker,
	// 	// 标记点的文字标注
	// 	BmLabel,
	// 	// 标注弹窗
	// 	BmInfoWindow,
	// },
	data() {
		return {
			manageShow:0,
			footerBackgroundImage: "",
			footerBackgroundColor: "#383d61",
			footerFontColor: "white",
			// baiduMap:{
			// 	center:{ // 贵阳市：26.530804, 106.688479；
			// 		lng: 106.688479, 
			// 		lat: 26.530804
			// 	},
			// 	zoom:15,
			// },
			// keyword: '',
			// BMap:null,// 地图组件是否就绪
			// BAddress:'',
			
			gaoDeMap:{
				content: '公司名称',// 106.688244,26.530928；贵阳市：106.628201,26.646694
				center:{ // 26.530804, 106.688479
					lng: 106.688244, 
					lat: 26.530928
				},
				zoom:15,
				rotation: 0,
			},
			
			isShowPanel: true,
			isShowInfo: false,
			bottomInfoList:[
				{itemIndex:0, itemName:"", itemValue:"", itemAlias:"", itemDetail:""}, 
				{itemIndex:0, itemName:"", itemValue:"", itemAlias:"", itemDetail:""}, 
				{itemIndex:0, itemName:"", itemValue:"", itemAlias:"", itemDetail:""}, 
				{itemIndex:0, itemName:"", itemValue:"", itemAlias:"", itemDetail:""},
				{itemIndex:0, itemName:"", itemValue:"", itemAlias:"", itemDetail:""},
				{itemIndex:0, itemName:"", itemValue:"", itemAlias:"", itemDetail:""},
				{itemIndex:0, itemName:"", itemValue:"", itemAlias:"", itemDetail:""},
				{itemIndex:0, itemName:"", itemValue:"", itemAlias:"", itemDetail:""},
				{itemIndex:0, itemName:"", itemValue:"", itemAlias:"", itemDetail:""},
				{itemIndex:0, itemName:"", itemValue:"", itemAlias:"", itemDetail:""},
				{itemIndex:0, itemName:"", itemValue:"", itemAlias:"", itemDetail:""},
				{itemIndex:0, itemName:"", itemValue:"", itemAlias:"", itemDetail:""},
			],
			itemId_bottom_info: 0,
			product_length: 0,
			product_begin: 0,
			product_end: 0,
			QR_begin: 0,
			QR_end: 0,
			product_before_len: 8,
			QR_before_len: 9,
			QR_code_length: 0,
			QR_code_len: 0,
			isVisable: false,
			beianUrl:'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52010202004128',
			serveUrl:'http://xny.world',
			backServeUrl: process.env.VUE_APP_SERVER,
			networkSecurityPicUrl: 'https://img.zwfw.guizhou.gov.cn/upload/202101/11/51db175a6734464b90c68381d47a3172.png',
		}
	},
	mounted() {
		this.showEditIcon(this.getUrlKey('showEditIcon'));
		this.initAMap();
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	created() {
		this.getItemList();
	},
	computed: {
		strToObj(str){
			return JSON.parse(str)
		},
	},
	methods: {
		
		getItemList(){
			this.getRequest("/api/list/items", {typeKey:'m_0_2_bottom_info'}).then(resp =>{
				if (resp){
					this.bottomInfoList = resp.m_0_2_bottom_info.itemVOList;
					this.checkProductLen();
					
					// console.log("集合长度：", Object.keys(this.bottomInfoMap).length, '产品数：', this.product_length)
					this.itemId_bottom_info = resp.m_0_2_bottom_info.cid
					
					var firstItem = this.bottomInfoList[0]
					this.footerBackgroundImage = firstItem.itemDetail
					
					var backgroundColor = firstItem.itemValue;
					if(backgroundColor != '') this.footerBackgroundColor = backgroundColor;
					
					var fontColor = this.bottomInfoList[1].itemValue;
					if(fontColor != '') this.footerFontColor = fontColor;
					
					const sixItem = this.bottomInfoList[6];
					const serveUrl = sixItem.itemName;
					if(serveUrl != '') this.serveUrl = serveUrl;
					
					const backServeUrl = sixItem.itemAlias;
					if(backServeUrl != '') this.backServeUrl = backServeUrl;
					
					const networkSecurityPicUrl = sixItem.itemDetail
					if(networkSecurityPicUrl != '') this.networkSecurityPicUrl = networkSecurityPicUrl;
					
					this.checkQRCodeLen();
					
					this.setMapVal();	// 设置地址导航信息
				}
			});
		},
		
		checkProductLen(){
			var sevenE = this.bottomInfoList[7];
			this.product_begin = parseInt(sevenE.itemAlias);
			this.product_end = parseInt(sevenE.itemDetail);
		},
		
		checkQRCodeLen(){
			var eightE = this.bottomInfoList[8];
			this.QR_begin = parseInt(eightE.itemAlias);
			this.QR_end = parseInt(eightE.itemDetail);
		},
		
		handleScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop === 0) {
				// console.log('滚动到了顶端');
				// 在这里执行当你滚动到顶端时想要执行的代码
				$("#side-toolbar").css("display", "none");
			}
			if (scrollTop >= 1500) {
				this.isVisable = true; //大于1500时显示元素
			}
			if (scrollTop < 1500) {
				this.isVisable = false; //小于1500时隐藏元素
			}
		},
		
		goTop(){
			window.scrollTo(0, 0);
			this.isVisable = false;
		},
		
		getUrlKey(name){
		   return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
		},
		// 生成m到n的连续自然数组(m < n)
		generateNumbers(m, n) {
		  if (m > n) {
		    return [];
		  } else {
		    return [m].concat(this.generateNumbers(m+1, n));
		  }
		},
		
		/**
	      * 监听地图是否加载完成
	      * */
	    handler(lng, lat){
			const that = this
			var myGeo = new BMap.Geocoder();
			var pt = new BMap.Point(lng, lat);
			console.log('lng：'+lng)
			console.log('lat：'+lat)
			myGeo.getLocation(pt, function(result){
				that.BAddress = result.address; //获取到当前定位的详细地址信息
				console.log("BAddress0:"+ that.BAddress)
			});
		},
		
		search (e) {},
		
		showPanel() {
			//点击标注出现弹框
			this.isShowPanel = !this.isShowPanel;
		},
	
		infoWindowClose() {
			//弹框关闭
			this.isShowInfo = false;
		},
	
		infoWindowOpen() {
			//弹框打开
			this.isShowInfo = true;
		},
		
		// handleLabelDoubleClick(){
		// 	var path = "http://api.map.baidu.com/marker?location=26.531160,106.688169&title=公司位置&content=宜家尚城&output=html";
		// 	var path = "https://map.baidu.com/poi/宜家尚城&output=html";
		// 	window.open(path);
		// },
		
		setMapVal(){
			this.gaoDeMap.center.lng 	= this.bottomInfoList[3].itemValue
			this.gaoDeMap.center.lat 	= this.bottomInfoList[3].itemAlias
			this.gaoDeMap.rotation 		= this.bottomInfoList[4].itemValue
			this.gaoDeMap.zoom 			= this.bottomInfoList[4].itemDetail
			this.gaoDeMap.content		= this.bottomInfoList[3].itemDetail
		},
		
		initAMap() {
				// 高德地图key和安全密钥的使用指南 https://www.quanzhan.co/archives/464
			 // 参考：https://blog.csdn.net/keke11211/article/details/124683754
			var securityJsCode = (process.env.NODE_ENV === 'development')	?	('securityJsCode'):
							(process.env.NODE_ENV === 'production_test')? 	('securityJsCode'):
							(process.env.NODE_ENV === 'production_pre')	? 	('serviceHost'):
							(process.env.NODE_ENV === 'production')		?	('serviceHost'):('');
			window._AMapSecurityConfig = {securityJsCode: process.env.VUE_APP_AMAP_SECURITY_JS_CODE_QUERY};
			// window._AMapSecurityConfig = {
			// 	// securityJsCode: "**************",
			// };
			// console.log("securityJsCode-key:"+securityJsCode)
			// console.log("securityJsCode-val:"+process.env.VUE_APP_AMAP_SECURITY_JS_CODE_QUERY)
			AMapLoader.load({
				// key: '***************', // 申请好的Web端开发者Key，首次调用 load 时必填
				key: process.env.VUE_APP_AMAP_KEY, // 申请好的Web端开发者Key，首次调用 load 时必填
				version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
				plugins: ['AMap.Marker'], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
			})
			.then((AMap) => {
				this.map = new AMap.Map("mapAddr", {
					// 设置地图容器id
					viewMode: "2D", // 设置地图模式 '2D'\'3D'
					zooms: [1, 20],	// 缩放范围
					zoom: this.gaoDeMap.zoom, // 初始化地图级别 
					center: [this.gaoDeMap.center.lng, this.gaoDeMap.center.lat], // 初始化地图中心点位置
					// pitch: 55,	// 倾斜角度
					rotation: this.gaoDeMap.rotation,	// 旋转角度
					center: [this.gaoDeMap.center.lng, this.gaoDeMap.center.lat],
					// 【地图的显示样式】 normal:标准（默认值）; whitesmoke:远山黛; macaron:马卡龙; graffiti:涂鸦; 
					// darkblue:极夜蓝; blue:靛青蓝; fresh:草色青; dark:幻影黑; light:月光银; grey:雅士灰;
					mapStyle: "amap://styles/normal",// "amap://styles/whitesmoke", //(远山黛)设置地图的显示样式
				});
				
				// 自定义标记点的内容
				var content = `
				<div style="width: 200px;height:50px;display: flex;flex-wrap: wrap;justify-content: center;">
						<div style="background: #fff;width:200px;font-size: 14px;padding:5px 2px;border: 1px solid #A8ABB2;box-shadow: 1px 1px 5px 2px rgba(0,0,0,0.08);">
								<p>客服电话：${this.gaoDeMap.content}</p>
								<p style="margin-top: 5px;">公司地址：${this.gaoDeMap.content}</p>
						</div>
				</div>
				`;
				//创建一个 Marker 实例：
				const marker = new AMap.Marker({
					position: new AMap.LngLat(this.gaoDeMap.center.lng, this.gaoDeMap.center.lat), //经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
					title: this.gaoDeMap.content,//this.gaoDeMap.content,//"北京", // 鼠标移入显示的提示
					// icon: "http://vdata.amap.com/icons/b18/1/2.png", // 红星
					// icon: "https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png", // 蓝色水滴(默认值)
					// icon: "https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png", // 红色水滴(采用值)
					// content: content, // this.gaoDeMap.content,  // 自定义点标记覆盖物内容
					icon: new AMap.Icon({
							// size: new AMap.Size(36, 36),
							image: "https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png",
							imageSize: new AMap.Size(24, 30),
							// imageOffset: new AMap.Pixel(0, 0)
						}),
					anchor:'bottom-center', // 设置锚点方位
					map: this.map
				});
				
				this.map.add(marker); //添加 点标记
				// this.map.setFitView(); //缩放地图到合适的视野级别
			})
			.catch((e) => {
				console.log(e);
			});
		},
		
		manageShowClick(){
			this.manageShow ++;
			if (this.manageShow > 5) this.manageShow = 0;
			// alert("当前计数："+ this.manageShow)
		},
	}
}
</script>

<style scoped>
		
	.bm-view {
		width: 100%;
		height: 145px;
		padding-top: 5px;
		margin-top: 10px;
	}

	/* #container{
		padding:0px;
		margin: 0px;
		width: 100%;
		height: 800px;
	} */
	
	#mapAddr {
		width: 100%;
		height: 145px;
		padding-top: 5px;
		margin-top: 30px;
	}
	.amap-icon{
	  overflow:inherit !important;
	}
	.separator {
	  color: #666;
	}
</style>
